// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const alertBannerClasses = {
  action: "qui-alert-banner__action",
  closeButton: "qui-alert-banner__close-button",
  description: "qui-alert-banner__description",
  heading: "qui-alert-banner__heading",
  icon: "qui-alert-banner__icon",
  root: "qui-alert-banner__root",
} as const
